import type {MouseEvent, ReactElement} from 'react';
import {clsx} from 'clsx';
import styles from './index.module.scss';

interface Props {
    className?: string;

    onClick(event: MouseEvent): void;
}

export default function Cross(props: Props): ReactElement {
    const classes = clsx({
        [styles.cross]: true,
        [props.className as string]: props.className,
    });
    return <div className={classes} onClick={props.onClick} />;
}
